import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="breadcrumb contain">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="breadcrumb-item">
            {isLast ? (
              <span className="breadcrumb-current">{item.name}</span>
            ) : (
              <>
                <Link to={item.link}>{item.name}</Link>
                {/* {" / "} */}
              </>
            )}
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
